import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux'
import { CookiesProvider } from "react-cookie";

//import MainRouter from "@components/MainRouter";
import MainRouter from "./components/MainRouter";

import { config } from "../src/Config";
import store from "./store/index";

import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./common/utility/extensions";

function App() {

  return (
    <Provider store={store}>
      <CookiesProvider>
        <Router basename={config.url.BASENAME}>
          <MainRouter />
        </Router>
      </CookiesProvider>
    </Provider>
  );
}

export default App;
